/**
 * 法语（fr）
 */

import frLocale from 'element-ui/lib/locale/lang/fr'
import publish from './publish/fr'
import personal from './personal/fr'
import order from './order/fr'
import customProduct from './customProduct/fr'
import index from './index/fr'
export default {
  ...frLocale,
  currency: {
    product: 'Produits',
    inStock: 'Inventaire',
    myProduct: 'Mes Produits',
    listings: 'Liste de contrôle',
    wishList: 'Liste des souhaits',
    allOrder: 'Tout va bien.',
    store: 'Centre commercial',
    personalCenter: 'Centres personnels',
    payment: 'Paiements',
    address: 'Adresse',
    accountSettings: 'Configuration du compte',
    logOut: 'Passation par profits et pertes',
    cancel: 'Annulation',
    submit: 'Présentation',
    selectAll: 'Sélectionner tout',
    confirmOrder: 'Confirmer la commande',
    back: 'Reviens!',
    customProduct: 'Produits sur mesure',
    home: 'La maison',
    newIn: 'Nouveau.',
    deleteTip: 'Êtes - vous sûr de vouloir supprimer le produit sélectionné?',
    delete: 'Supprimer'
  },
  // 语言
  lang: {
    english: 'Anglais',
    chinese: 'En chinois',
    spanish: 'Espagnol',
    japanese: 'Japonais',
    portuguese: 'Portugais',
    french: 'Français',
    russian: 'Russe',
    arabic: 'Arabe',
    german: 'Allemagne',
    italian: 'Italien',
    vietnam: 'Viet Nam',
    turkey: 'Turquie',
    korean: 'Coréens',
    thai: 'Thai',
    dutch: 'Néerlandais',
    hebrew: 'Hébreu',
    indonesian: 'Indonésien'
  },

  // 苏子龙
  // 现货页面 inSrock
  inSrock: {
    category: 'Catégorie',
    search: 'chercher',
    searchingFor: 'Séparer plusieurs recherches par des virgules ou des espaces',
    shippingFrom: 'Expédition de',
    fabric: 'en tissu',
    price: 'Prix',
    inventory: 'Inventaire',
    newest: 'Le plus récent',
    sales: 'Ventes',
    min: 'Min',
    max: 'Max.',
    recentSearches: 'Recherches récentes',
    hotSearches: 'Recherche populaire'
  },
  // 商品详情页
  productDetail: {
    product: 'Produits',
    detail: 'Détails',
    itemNo: 'Numéro du projet',
    processingTime: 'Temps de traitement',
    shippingCost: 'Frais de transport',
    paymentMethod: 'Mode de paiement',
    sizeGuide: 'Tableau des tailles',
    color: 'Couleur',
    size: 'Taille',
    viewAllVariants: 'Voir toutes les variantes',
    allVariants: 'Toutes les variantes',
    shipFrom: 'De',
    addToCart: 'Ajouter au panier',
    listToStore: 'Liste à stocker',
    addToWishList: 'Ajouter à la liste des souhaits',
    description: 'Description',
    return: 'Retour',
    refundPolicy: 'Politique de remboursement',
    shipping: 'Transport maritime',
    image: 'Image',
    action: 'Action',
    // 选项卡/shipping
    packingSize: `Taille de l'emballage`,
    packingWeight: `Poids de l'emballage`,
    shippingFrom: 'De',
    shippingTo: 'Transport vers',
    qty: 'Nombre',
    maximum: 'Stock maximum:',
    shippingMethod: 'Mode de transport',
    estimatedDeliveryTime: 'Délai de livraison prévu',
    sizeChart: 'Tableau des tailles',
    deliveryTime: 'Délai de livraison',
    outOfStockTips: 'Désolé, il manque!',
    pleaseSelected: 'Veuillez sélectionner',
    customerReviews: 'Commentaires des clients',
    writeAReview: 'Écrivez un commentaire'
  },
  // 购物车
  shoppingCart: {
    shoppingCart: 'Panier',
    topTip: 'Sélectionnez un produit dans le même entrepôt pour passer une commande.'
  },
  // 确认订单
  confirmOrder: {
    shippingAddress: 'Adresse de livraison',
    addNewAddress: 'Ajouter une nouvelle adresse',
    selectAnotherAddress: 'Sélectionner une autre adresse',
    editTheAddress: `Modifier l'adresse`,
    remark: 'Commentaires',
    unitPrice: 'Prix unitaire',
    totalPayable: 'Total dû',
    itemSubtotal: 'Total partiel, projets',
    subtotal: 'sous-total',
    shippingSubtotal: 'Total partiel, transports maritimes',
    promotion: 'Promotion',
    grandTotal: 'Total général',
    creditCard: 'Carte de crédit',
    balance: 'Équilibre',
    payNow: 'Payez maintenant.',
    commonProblem: 'Questions fréquemment posées',
    emailVerification: 'Vérification par courriel',
    verificationTitle: 'Le Code de vérification a été envoyé à votre courriel',
    verification: 'Validation',
    seconds: 'Secondes',
    laterGetPasswordAgain: 'Obtenir le mot de passe plus tard',
    sendAgain: 'Envoyer à nouveau'
  },
  // 账号设置弹窗
  setting: {
    setting: 'Contexte',
    fullName: 'Nom complet',
    email: 'E - mail',
    password: 'Mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    notVerified: 'Non vérifié',
    change: 'Changement',
    codeSend: 'Le Code de vérification a été envoyé à votre courriel'
  },
  // 张丰
  ...personal,

  // 孙泽严
  ...publish,
  ...order,
  ...customProduct,

  ...index
}
